<template>
  <button type="button" class="flex w-full items-center justify-between">
    <span class="text-text-neutral-primary text-sm">
      <slot></slot>
    </span>
    <!-- prettier-ignore -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="#636366" fill-rule="evenodd" d="M7.958 20.79a.985.985 0 0 1-.439-.657.917.917 0 0 1 .214-.741L14.03 12 7.733 4.608a.917.917 0 0 1-.214-.74.985.985 0 0 1 .439-.658c.118-.082.255-.142.4-.176a1.262 1.262 0 0 1 .867.108c.129.069.24.16.33.267l6.658 7.812c.191.224.295.498.295.779s-.104.555-.295.78l-6.658 7.81c-.09.108-.201.2-.33.268a1.26 1.26 0 0 1-.867.108 1.187 1.187 0 0 1-.4-.175Z" clip-rule="evenodd"/></svg>
  </button>
</template>
